import React, { useContext, useState } from "react";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import TextField from "@mui/material/TextField";
import DialogTitle from "@mui/material/DialogTitle";
import Slide from "@mui/material/Slide";
import CircularProgress from "@mui/material/CircularProgress";
import IconButton from "@mui/material/IconButton";
import { Add, Done } from "@mui/icons-material";
import clienteAxios from "../../../../../config/axios";
import { CursoContext } from "../../../../../context/curso_context";

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

export default function CrearSubCategoriaEnCurso({
  categorias,
  update,
  setUpdate,
  setSnackbar,
}) {
  const [open, setOpen] = React.useState(false);
  const [subCategorie, setSubCategorie] = useState("");
  const [loading, setLoading] = useState(false);
  const token = localStorage.getItem("token");
  const { datos, setDatos } = useContext(CursoContext);

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const onChangeSubcategory = (value) => {
    const categoria = capitalizarPrimeraLetra(value);
    setSubCategorie(categoria);
  };

  function capitalizarPrimeraLetra(str) {
    return str.charAt(0).toUpperCase() + str.slice(1);
  }

  const handleSubmit = async () => {
    //verificar subcategorias vacias
    const category = categorias.filter(
      (res) => res.categorie === datos.category
    );
    if (!subCategorie) return;
    if (category.length === 0) return;
    setLoading(true);
    await clienteAxios
      .post(
        `/categories/subcategories/${category[0]._id}`,
        { subCategorie },
        {
          headers: {
            Authorization: `bearer ${token}`,
          },
        }
      )
      .then((res) => {
        setLoading(false);
        setSubCategorie("");
        setSnackbar({
          open: true,
          mensaje: res.data.message,
          status: "success",
        });
        setDatos({
          ...datos,
          subCategory: subCategorie,
        });
        setUpdate(!update);
        handleClose();
      })
      .catch((err) => {
        setLoading(false);
        if (err.response) {
          setSnackbar({
            open: true,
            mensaje: err.response.data.message,
            status: "error",
          });
        } else {
          setSnackbar({
            open: true,
            mensaje: "Al parecer no se a podido conectar al servidor.",
            status: "error",
          });
        }
      });
  };

  return (
    <div>
      <IconButton variant="contained" color="primary" onClick={handleClickOpen} disabled={!datos.category}>
        <Add />
      </IconButton>
      <Dialog
        open={open}
        TransitionComponent={Transition}
        keepMounted
        onClose={(_, reason) => {
          if (reason !== "backdropClick") {
            handleClose();
          }
        }}
        aria-labelledby="new-category"
        fullWidth
        maxWidth="sm"
      >
        <DialogTitle id="new-category">Nueva categoria</DialogTitle>
        <DialogContent>
          <TextField
            fullWidth
            size="small"
            label="Subcategoria"
            variant="outlined"
            onChange={(e) => onChangeSubcategory(e.target.value)}
            value={subCategorie}
          />
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose} color="inherit" disabled={loading}>
            Cancelar
          </Button>
          <Button
            disabled={loading}
            onClick={() => handleSubmit()}
            color="primary"
            startIcon={
              loading ? (
                <CircularProgress color="inherit" size={20} />
              ) : (
                <Done />
              )
            }
          >
            Guardar
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
}
